import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EMBEDDED_CUSTOMER_STATUSES } from 'pages/EmbeddedCustomers/helpers/constants'
import {
  DASHBOARD_CARD_VISUAL_TYPES,
  DashboardCardState,
} from 'pages/EmbeddedCustomers/helpers/types'

export const useDashboardCards = (initialActiveCard?: string) => {
  const [activeCard, setActiveCard] = useState<string | null>(initialActiveCard || null)

  const handleCardClick = useCallback((step: string) => {
    setActiveCard(prevStep => (prevStep === step ? null : step))
  }, [])

  const { t } = useTranslation()

  const dashboardCards = useMemo<DashboardCardState[]>(
    () => [
      {
        step: '1',
        title: t('embeddedCustomers.dashboard.agreements'),
        status: EMBEDDED_CUSTOMER_STATUSES.PENDING_AGREEMENTS,
        queue: '0',
        type: DASHBOARD_CARD_VISUAL_TYPES.NEUTRAL,
      },
      {
        step: '2',
        title: t('embeddedCustomers.dashboard.dataCollection'),
        status: EMBEDDED_CUSTOMER_STATUSES.INFO_REQUIRED,
        queue: '0',
        type: DASHBOARD_CARD_VISUAL_TYPES.NEUTRAL,
      },
      {
        step: '3',
        title: t('embeddedCustomers.dashboard.decisionApproval'),
        status: EMBEDDED_CUSTOMER_STATUSES.PENDING,
        queue: '0',
        type: DASHBOARD_CARD_VISUAL_TYPES.NEUTRAL,
      },
      {
        step: '4',
        title: t('embeddedCustomers.dashboard.walletCreation'),
        status: EMBEDDED_CUSTOMER_STATUSES.VERIFIED,
        queue: '0',
        type: DASHBOARD_CARD_VISUAL_TYPES.NEUTRAL,
      },
      {
        step: '5',
        title: t('embeddedCustomers.dashboard.onboarded'),
        status: EMBEDDED_CUSTOMER_STATUSES.VERIFIED,
        queue: '0',
        type: DASHBOARD_CARD_VISUAL_TYPES.SUCCESS,
      },
    ],
    []
  )

  return {
    activeCard,
    handleCardClick,
    dashboardCards,
  }
}
